import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetLateFeeConfigsQuery } from "../../../hooks/useGetLateFeeConfigsQuery";
import { LateFeeConfigType } from "../../../types/Finance";
import { Key_lateFeeConfigs } from "../../../utils/constants";
import toast from "react-hot-toast";
import { updateLateFeeConfig } from "../../../services/finance/lateFeeConfig";
import { routes } from "../../../routes";
import { setLateFeeConfigData } from "../../../redux/slices/finance/lateFeeConfig";
import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";

const columnNamesMap: { [key: string]: string } = {
  paymentType: 'Tipo de emolumento',
  feeAmount: 'Taxa de pagamento',
  feePercentage: 'Percentagem de pagamento',
  startDay: 'Dia inicial',
  endDay: 'Dia limite',

};

export const LateFeeConfigs = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetLateFeeConfigsQuery({ PageNumber: currentPage, PageSize: 400 });
  const [deleteItem, setDeleteItem] = useState<LateFeeConfigType | null>(null);
  const mutationUpdate = useMutation(updateLateFeeConfig, {
    onSuccess: () => {
        queryClient.invalidateQueries(Key_lateFeeConfigs);
        toast.success('Regra  apagada');
    },
    onError: () => {
        toast.error("Erro ao apagar Regra.")
    }
});
const handlePageChange = (page: number) => {
  setCurrentPage(page);
};
const handleClickCreate = (event: any): void => {
  navigate(routes.createlateFeeConfig)
}
const handleEdit = (c: LateFeeConfigType) => {
  dispatch(setLateFeeConfigData(c));
  navigate(routes.updatelateFeeConfig)
};
const handleDelete = (c: LateFeeConfigType) => {
  c.status = false;
  mutationUpdate.mutateAsync(c)
};
const openDeleteDialog = (s: LateFeeConfigType) => {
  setDeleteItem(s);
};  
const confirmDelete = async () => {
  if (deleteItem) {
      await handleDelete(deleteItem!)
  }
};
const options = data?.items.map((c: LateFeeConfigType) => [
  {
      label: 'Editar',
      onClick: () => handleEdit(c),
      icon: <Pencil1Icon />
  },
  {
      label: 'Excluir',
      onClick: () => openDeleteDialog(c),
      icon: <TrashIcon />
  }
]) || [];

return (
  <>
      <Lists
          status={status}
          TableComponent={() =>
              <TableComponent
                  columns={Object.keys(columnNamesMap)}
                  items={data?.items}
                  options={options}
                  columnNamesMap={columnNamesMap}
                  totalPages={data?.totalPages || 1}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
              />
          }
          handleClickCreate={handleClickCreate}
      />
      <ConfirmAlertDialog
          open={!!deleteItem}
          onOpenChange={(open) => !open && setDeleteItem(null)}
          title="Esta operação é irreversível"
          item={deleteItem}
          onConfirm={confirmDelete}
          onCancel={() => setDeleteItem(null)}
      />
  </>
);
}
